import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import iconSeta from '../../../assets/img/ico-seta.svg'
import { generatePath, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
SwiperCore.use([EffectCoverflow, Pagination]);
const Noticias = (prop: any) => {

  const [noticias, setNoticias] = useState<any[]>([]);

  const Setlocation = (id: any, nav: boolean) => {
    var url = id.Title;
    var Id = id.Id;
    var urlParamTrim = url?.substring(0, 50).normalize("NFD").replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g, '-');
    if (urlParamTrim === undefined || urlParamTrim == null) {
      urlParamTrim = "Noticias...";
    } else {
      urlParamTrim = urlParamTrim + "...";

    }
    var searchParams = new URLSearchParams(urlParamTrim);
    searchParams.set("Id", Id);
    var path = "/noticias-internas/" + searchParams.toString();
    if (nav) {
      navigate(generatePath(path));
    } else {
      return generatePath(path);
    }

  }
  useEffect(() => {
    api
      .get(prop.url)
      .then((response) => {

        setNoticias(response.data.results);

      })
      .catch((err) => {
        throw new Error(err);

      });
  }, [prop.url]);

  let navigate = useNavigate();

  function formatDateAno(dateUtc: any) {
    if (dateUtc) {
      return new Date(dateUtc).getDate() + ' de ' + new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' }).toString() + ' de '
        + new Date(dateUtc).getFullYear().toString();
    }
  }

  function ReplaceUrl(_url: any) {
    if (_url) {
      return _url.replace("http:", "https:");
    }
    else {
      return '../assets/img/noticias-default.png';
    }
  }

  //arrows
  const [swiperIndex, setSwiperIndex] = useState(0);

  const handlePrevClick = () => {
    setSwiperIndex((prevIndex) => prevIndex - 1);
  };

  const handleNextClick = () => {
    setSwiperIndex((prevIndex) => prevIndex + 1);
  };

  const isPrevDisabled = swiperIndex === 0; // Disable prev button when swiperIndex is 0
  const isNextDisabled = swiperIndex === 2; // Disable next button when swiperIndex is at the maximum

  function addDefaultSrcFiltro(ev: any) {
    ev.target.src = '../assets/img/noticias-default.png';
  }


  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobile = windowWidth < 590;

  return (
    <section key={new Date().getTime()} className="noticias py-6 pt-lg-10">
      <div className="container">
        <div className="row">
          <div className="col-lg-3">
            <h2 className="text-primary">
              <span className="d-none d-lg-block">
                {" "}
                Últimas <br /> notícias{" "}
              </span>
              <span className="d-lg-none"> Notícias </span>
            </h2>
          </div>
          <div className="col-lg-9">
            <div className="row loaded">
              {<Swiper

                grabCursor={true}
                slidesPerView={"auto"}
                initialSlide={swiperIndex}
                pagination={false}
                
                breakpoints={{
                  // when window width is >= 640px
                  384: {
                    width: 312,
                    slidesPerView: "auto",
                    //spaceBetween: 10,
                  },
                  // when window width is >= 430px
                  430: {
                    width: 312,
                    slidesPerView: "auto",
                    //spaceBetween: 35,                    
                  },
                  // when window width is >= 768px
                  590: {
                    width: 590,
                    slidesPerView: 2,  
                    //spaceBetween: 20,
                  },
                }
                }
                //style={{ marginLeft: isMobile ? "50px" : "0" }}

              >
                {noticias?.map((item, index) => (
                  <SwiperSlide key={index} >
                    <div className='col-lg-12 col-md-6 load-post border' >
                      <div className="card-noticia card-noticia_centr_img pr-md-3 pl-lg-4"
                        style={{ display: "grid" }}>
                        <div className="card-noticia__title">
                          <p> {item?.Categoria?.Title?.toUpperCase()}&nbsp;</p>
                        </div>
                        <div onClick={() => Setlocation(item, true)} style={{ cursor: "pointer", display: "grid" }} className="card-noticia__img">
                          <a href={Setlocation(item, false)}>
                            <img src={ReplaceUrl(item?.UrlIcone)} onError={addDefaultSrcFiltro} alt="Imagem" /> </a>
                        </div>
                        <div className="card-noticia__desc">
                          <a href={Setlocation(item, false)}>
                            <h2 className="h4">
                              {item?.Title}</h2> </a>
                          <span>
                            {item.Descricao}
                          </span>
                        </div>
                        <div className="card-noticia__data"> <p> {formatDateAno(item.DataInicio)} </p>	</div>
                        <div onClick={() => Setlocation(item, true)} style={{ cursor: "pointer" }} className="card-noticia__link d-none d-lg-block">

                          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>

                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}</Swiper>}
            </div>
          </div>

          <div className="col-12 d-lg-none">
            <div className="d-flex align-items-center justify-content-end mt-10">
              <div className={`swiper-button-prev swiper-button noticias-prev ${isPrevDisabled ? 'swiper-button-disabled' : ''}`}>
                <svg onClick={handlePrevClick} className="swiper-arrow swiper-arrow-prev" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
                </svg>
              </div>
              <div className="arrow-w">
                <div className={`swiper-button-next swiper-button noticias-next ${isNextDisabled ? 'swiper-button-disabled' : ''}`}>
                  <svg onClick={handleNextClick} className="swiper-arrow swiper-arrow-next" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 offset-lg-3">
            <a href="../acontece-na-forluz/noticias " className="d-flex align-items-center todas-noticias">
              <span>Ver todas as notícias</span>
              <img
                src={iconSeta}
                alt="Seta"
                className="transition"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Noticias;
